<script setup lang="ts">
import { computed } from "vue";

import { getTranslationObject } from "@/helpers/translation";

const props = defineProps<{
    error: {
        id: string;
        action: string;
        key: string;
        data: Record<string, string>;
        _default: string;
        _html: string;
        _link: string;
    };
}>();

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
const errorMessage = computed<any>(() => {
    return getTranslationObject(`errors.${props.error.id}`);
});

const actionError = computed(() => {
    // biome-ignore lint/complexity/useOptionalChain: Init Biome
    return errorMessage.value && errorMessage.value[props.error.action];
});

const contextError = computed(() => {
    // biome-ignore lint/complexity/useOptionalChain: Init Biome
    return errorMessage.value && errorMessage.value[props.error.key];
});

const defaultError = computed(() => {
    // biome-ignore lint/complexity/useOptionalChain: Init Biome
    return errorMessage.value && errorMessage.value._default;
});

const defaultHtmlError = computed(() => {
    // biome-ignore lint/complexity/useOptionalChain: Init Biome
    return errorMessage.value && errorMessage.value._html;
});

const defaultHtmlErrorMessage = computed(() => {
    const message: string = errorMessage.value._html;
    const link = Object.keys(props.error.data).reduce(linkReducer, errorMessage.value._link);
    return message.toString().replace("{href}", link);
});

const linkReducer = (acc: string, currentKey: string) => {
    return acc.replace(`{${currentKey}}`, props.error.data[currentKey]);
};
</script>
<template>
    <div v-if="error" class="error">
        <template v-if="actionError">{{ actionError }}</template>
        <template v-else-if="contextError">{{ contextError }}</template>
        <template v-else>
            <span v-if="defaultError" v-html="defaultError"></span>
            <span v-else-if="defaultHtmlError" v-html="defaultHtmlErrorMessage"></span>
        </template>
    </div>
</template>
<style scoped lang="scss">
.error {
    color: $red;
    font-weight: $bold;
    text-align: left;
    padding-left: calc($padding / 2);
}
</style>
